import type { MouseEvent } from 'react';
import useTaskActions from '@modules/TasksModule/hooks/useTaskActions';
import useBookingRetentionEnabled from '@modules/InboxModule/hooks/useBookingRetentionEnabled';
import { closeEndedCall } from './closeEndedCall';

/**
 * The Close handler of an ended call card. Retention on: the card's own click
 * target would re-select the card after an async Close, so the click must not
 * bubble. Off: today's synchronous handler.
 */
export function useCloseEndedCallHandler(taskId: string) {
  const { handleComplete } = useTaskActions(taskId);
  const isRetentionEnabled = useBookingRetentionEnabled();
  return isRetentionEnabled
    ? (event: MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        void closeEndedCall(taskId);
      }
    : handleComplete;
}
